export default __webpack_public_path__ + "a7dd0dc8d76bfa61d0472c4f63eb2e74.png";